function showArchivesFilter () {
  const btnFilter = document.querySelector(".btn-filter");
  const archivesDesktopTabs = document.querySelector(".archives-desktop-tabs");
  const boxFilterAndResults = document.querySelector(".box-filter-and-results");

  if (btnFilter) {
    btnFilter.addEventListener("click", (event) => {
      archivesDesktopTabs.classList.toggle("d-none");
      boxFilterAndResults.classList.toggle("d-none");
      btnFilter.classList.toggle("btn-filter-active");
    });
  }
}

function openPpTab(event, tabName) {
  // Declare all variables
  var i, tabcontent, tablinks;
  // Get all elements with class="tabcontent" and hide them
  tabcontent = document.getElementsByClassName("tabcontent");

  if (tabcontent) {
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }

    // Get all elements with class="tablinks" and remove the class "active"
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }

    // Show the current tab, and add an "active" class to the button that opened the tab
    document.getElementById(tabName).style.display = "block";
    event.currentTarget.className += " active";
  }
}

function openTabValides() {
  const btnTabValides = document.querySelector(".btn-tab-valides");
  if (btnTabValides) {
    btnTabValides.addEventListener("click", (event) => {
      openPpTab(event, 'valides');
    });
  }
}

function openTabArchives() {
  const btnTabArchives = document.querySelector(".btn-tab-archives");
  if (btnTabArchives) {
    btnTabArchives.addEventListener("click", (event) => {
      openPpTab(event, 'archives');
    });
  }
}

function openDefaultTab() {
  const defaultTab = document.getElementById("defaultOpen");
  if (defaultTab) {
    defaultTab.click();
  }
}

export { showArchivesFilter };
export { openTabValides };
export { openTabArchives };
export { openDefaultTab };
